var _excluded = ["appearance", "children", "customStyle", "color", "size", "disabled", "focusable"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import CustomImage from '../custom_image';
import propTypes from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Logo = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      appearance = 'singlecolor',
      children,
      customStyle,
      color = 'black',
      size = 32,
      disabled = false,
      focusable = false
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  var logoStyle = {
    '.svg-textcolor': {
      fill: 'currentColor'
    },
    '> *': {
      display: 'none'
    },
    ["> .".concat(appearance)]: {
      display: 'block'
    }
  };
  return ___EmotionJSX(CustomImage, _extends({
    customStyle: [logoStyle, customStyle],
    ref: ref,
    color: color,
    size: size,
    disabled: disabled,
    focusable: focusable
  }, other), children);
});
Logo.propTypes = propTypes;
Logo.displayName = 'Logo';
export default Logo;